<template>
  <div>
    <h5 role="button" @click="open = !open">
      <i v-if="!open" class="fas fa-angle-right"></i>
      <i v-if="open" class="fas fa-angle-down"></i>
      {{ title }}
    </h5>
    <b-collapse v-model="open" ref="collapse">
      <ais-hierarchical-menu :attributes="attributes">
        <template
          v-slot="{
            items,
            canToggleShowMore,
            isShowingMore,
            refine,
            toggleShowMore,
            createURL,
            sendEvent,
          }"
        >
          <styled-hierarchical-menu-list
            :items="items"
            :refine="refine"
            :createURL="createURL"
            :level="0"/>
          <button
            @click="toggleShowMore()"
            :disabled="!canToggleShowMore"
          >
            {{ isShowingMore ? 'Show less' : 'Show more' }}
          </button>
        </template>
      </ais-hierarchical-menu>
    </b-collapse>
  </div>
</template>

<script>
import StyledHierarchicalMenuList from "./StyledHierarchicalMenuList.vue";

export default {
  name: "StyledHierarchicalMenu",
  components: {StyledHierarchicalMenuList},
  data() {
    return {
      open: false,
      level: 0,
    }
  },
  props: {
    title: String,
    attributes: Array
  },
}
</script>

<style scoped>

</style>
